import { Logger } from '~~/helpers/logger';
import { errorToString } from '~~/helpers/error/errorToString';
import type { Address, ApiParams } from '~~/types/commercetools';
import { useCart } from '~/utils/ct/composables/useCart';

export function useBilling() {

  const { cart, load: loadCart } = useCart();

  const loading = useState<boolean>('useBilling-loading', () => false);
  const billing = useState<Address | null>('useBilling-billing', () => null);
  const error = useState<{
    load: string | null,
  }>('useBilling-error', () => ({
    load: null,
  }));

  async function load({ customQuery }: ApiParams = {}) {

    Logger.debug('useBilling.load');
    try {

      loading.value = true;

      if (!cart.value?.billingAddress) {

        await loadCart({ customQuery });
      
      }
      error.value.load = null;
      billing.value = cart.value?.billingAddress || null;
    
    } catch (err) {

      error.value.load = errorToString(err);
      Logger.error('useBilling/load', err);
    
    } finally {

      loading.value = false;
    
    }
  
  }

  return {
    billing: computed(() => billing.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
    load,
  };

}
